import {
  FilterOptions,
  SortOrder,
  SingleTicketTransformed,
} from 'src/components/Tickets/models/Tickets.interface';

export const generateSortQuery = (
  sortColumnId: keyof SingleTicketTransformed,
  sortOrder: SortOrder
) => {
  if (!sortColumnId || !sortOrder) {
    return null;
  }
  return `sortBy=${sortColumnId}&sortOrder=${sortOrder}`;
};

export const generateFilterQuery = (filterOptions: FilterOptions) => {
  const filterQueryArray = Object.entries(filterOptions)?.reduce(
    (acc, [columnId, options]) => {
      options?.forEach((option) => {
        option.checked && acc.push(`${columnId}[]=${option.id}`);
      });
      return acc;
    },
    [] as string[]
  );

  if (!filterQueryArray || filterQueryArray?.length === 0) {
    return null;
  }

  return filterQueryArray.join('&');
};
